var map = {
	"./サラダ.mp3": 4340,
	"./ビニールの.mp3": 3068,
	"./土地.mp3": 1556,
	"./帽子.mp3": 1212,
	"./手.mp3": 9612,
	"./捕まえる.mp3": 9532,
	"./猫.mp3": 5468,
	"./男・人.mp3": 7384,
	"./立つ.mp3": 2228,
	"./計画・計画する.mp3": 804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5768;